export function handleResize() {
	const nodeList = document.querySelectorAll<HTMLElement>(".box-sizing");
	nodeList.forEach((element) => {
		delete element.style.height;
		const curHeight = element.clientHeight;
		const newHeight = Math.ceil(curHeight / 50) * 50;
		element.style.minHeight = newHeight + "px";
	});
}